import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/**
 * @author PKr
 */
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

import { jsonConversions, MetadataReportDTOConverter, MetadataSimilarProductDTOConverter, TreeInfoDTOConverter } from '@logio/common-be-fe';
import { Inject } from '@logio/typescript-ioc';
import { CONSTANTS } from '../../../constants';
import api from '../../api';
import logger from '../../logger';
export var MetadataLayer =
/*#__PURE__*/
function () {
  function MetadataLayer() {
    _classCallCheck(this, MetadataLayer);
  }

  _createClass(MetadataLayer, [{
    key: "getSellouts",
    value: function getSellouts() {
      var _this = this;

      var limit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1000;
      var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      return api(CONSTANTS.API.ENDPOINTS.METADATA_REPORT_SELLOUT(limit, offset)).get({
        responseType: 'json'
      }).then(function (response) {
        return (response.data.result || []).map(function (item) {
          return _this.metadataDtoConverter.toObject(item, jsonConversions);
        });
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
    }
  }, {
    key: "getSimilar",
    value: function getSimilar() {
      var _this2 = this;

      var limit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1000;
      var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      return api(CONSTANTS.API.ENDPOINTS.METADATA_REPORT_SIMILAR(limit, offset)).get({
        responseType: 'json'
      }).then(function (response) {
        return (response.data.result || []).map(function (item) {
          return _this2.similarDtoConverter.toObject(item, jsonConversions);
        });
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
    }
  }, {
    key: "getNews",
    value: function getNews() {
      var _this3 = this;

      var limit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1000;
      var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      return api(CONSTANTS.API.ENDPOINTS.METADATA_REPORT_NEWS(limit, offset)).get({
        responseType: 'json'
      }).then(function (response) {
        return (response.data.result || []).map(function (item) {
          return _this3.metadataDtoConverter.toObject(item, jsonConversions);
        });
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
    }
  }, {
    key: "getHierarchy",
    value: function getHierarchy() {
      var _this4 = this;

      return api(CONSTANTS.API.ENDPOINTS.METADATA_REPORT_HIERARCHY).get({
        responseType: 'json'
      }).then(function (response) {
        return (response.data.result || []).map(function (item) {
          return _this4.treeInfoDtoConverter.toObject(item, jsonConversions);
        });
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
    }
  }]);

  return MetadataLayer;
}();

__decorate([Inject, __metadata("design:type", MetadataReportDTOConverter)], MetadataLayer.prototype, "metadataDtoConverter", void 0);

__decorate([Inject, __metadata("design:type", MetadataSimilarProductDTOConverter)], MetadataLayer.prototype, "similarDtoConverter", void 0);

__decorate([Inject, __metadata("design:type", TreeInfoDTOConverter)], MetadataLayer.prototype, "treeInfoDtoConverter", void 0);